import React, { createContext, useState, Children } from "react";
import { useTheme, SwipeableDrawer } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../localization/sharedResources.js";
import { MultiStepFilterHeader } from "./MultiStepFilterHeader.js";
const useClasses = makeStyles()((theme) => ({
  multiStepFilterDrawer: {
    display: "flex",
    overflowY: "hidden",
    flexDirection: "column",
    gap: theme.spacing(1.25),
    minHeight: "500px",
    maxHeight: "90%",
    borderTopLeftRadius: theme.spacing(1.75),
    borderTopRightRadius: theme.spacing(1.75)
  },
  multiStepFilterDrawerBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    flexGrow: 1
  },
  multiStepFilterDrawerHiddenFilter: {
    display: "none"
  },
  multiStepFilterDrawerActiveFilter: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }
}));
const DrawerContext = createContext(null);
function MultiStepFilterDrawer({ children, isOpen, onClose, onOpen }) {
  const { classes, cx } = useClasses();
  const theme = useTheme();
  const [activeFilterId, setActiveFilterId] = useState(null);
  function handleActivateFilter(index) {
    setActiveFilterId(index);
  }
  function handleDeactivateFilter() {
    setActiveFilterId(null);
  }
  function handleClose() {
    handleDeactivateFilter();
    onClose();
  }
  return /* @__PURE__ */ React.createElement(
    SwipeableDrawer,
    {
      "data-testid": "multiStepFilterDrawer",
      anchor: "bottom",
      open: isOpen,
      onClose: handleClose,
      onOpen,
      classes: { paper: classes.multiStepFilterDrawer },
      style: { zIndex: theme.zIndex.tooltip }
    },
    activeFilterId === null ? /* @__PURE__ */ React.createElement(MultiStepFilterHeader, { label: sharedLocalization.drawerLabel, onClose: handleClose }) : null,
    /* @__PURE__ */ React.createElement("div", { className: classes.multiStepFilterDrawerBody }, Children.map(children, (child, index) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "div",
      {
        key: index,
        className: cx(
          activeFilterId !== null && index === activeFilterId && classes.multiStepFilterDrawerActiveFilter,
          activeFilterId !== null && index !== activeFilterId && classes.multiStepFilterDrawerHiddenFilter
        )
      },
      /* @__PURE__ */ React.createElement(
        DrawerContext.Provider,
        {
          value: {
            onClose: handleClose,
            onActivate: () => handleActivateFilter(index),
            onDeactivate: handleDeactivateFilter
          }
        },
        child
      )
    ))))
  );
}
export {
  DrawerContext,
  MultiStepFilterDrawer
};
//# sourceMappingURL=MultiStepFilterDrawer.js.map
